import { ArrowUpRight } from "lucide-react";

/**
 * Premium coded "leads this month" dashboard: a steady, growing bar chart plus a
 * live feed of incoming leads from inbound / outbound / reactivation. Hero visual
 * for the Lead Generation page; shows a predictable, always-full pipeline.
 */
const bars = [38, 52, 47, 61, 58, 73];
const leads = [
  { initials: "MR", name: "Marcus R.", tag: "Google", color: "from-indigo-500 to-violet-500" },
  { initials: "SC", name: "Sara C.", tag: "Web form", color: "from-violet-500 to-fuchsia-500" },
  { initials: "TP", name: "Tom P.", tag: "Reactivation", color: "from-indigo-500 to-blue-500" },
];

export const LeadPipelineMockup = () => {
  const max = Math.max(...bars);
  return (
    <div className="relative w-full max-w-[400px] mx-auto select-none">
      {/* soft brand glow */}
      <div className="absolute -inset-8 -z-10 bg-[radial-gradient(circle_at_70%_25%,rgba(99,102,241,0.20),transparent_60%),radial-gradient(circle_at_25%_85%,rgba(139,92,246,0.14),transparent_60%)] blur-2xl" />

      {/* floating badge */}
      <div className="absolute -top-3 right-4 z-10 rounded-full bg-gradient-to-br from-indigo-600 to-violet-600 px-3.5 py-1.5 text-xs font-bold text-white shadow-lg shadow-indigo-900/20">
        Always-on pipeline
      </div>

      <div className="relative overflow-hidden rounded-[1.75rem] border border-black/[0.06] bg-white shadow-2xl shadow-indigo-900/10">
        {/* metric header */}
        <div className="border-b border-slate-100 px-5 py-4">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wide text-slate-600">New leads</span>
            <span className="flex items-center gap-1 text-xs font-bold text-emerald-700">
              <ArrowUpRight className="h-3.5 w-3.5" /> 18%
            </span>
          </div>
          <div className="mt-1 flex items-baseline gap-1.5">
            <span className="text-3xl font-bold tracking-tight text-slate-900">127</span>
            <span className="text-xs text-slate-600">this month</span>
          </div>

          {/* bar chart */}
          <div className="mt-3 flex h-16 items-end gap-1.5">
            {bars.map((b, i) => (
              <div
                key={i}
                className="flex-1 rounded-t-md bg-gradient-to-t from-indigo-500 to-violet-400"
                style={{ height: `${(b / max) * 100}%` }}
              />
            ))}
          </div>
        </div>

        {/* live incoming leads */}
        <div className="space-y-0.5 p-3">
          {leads.map((s) => (
            <div key={s.initials} className="flex items-center gap-3 rounded-xl px-2 py-2">
              <div className={`grid h-9 w-9 shrink-0 place-items-center rounded-full bg-gradient-to-br ${s.color} text-xs font-bold text-white`}>
                {s.initials}
              </div>
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-semibold text-slate-800">{s.name}</div>
                <div className="text-xs text-slate-600">New lead &middot; just now</div>
              </div>
              <span className="shrink-0 rounded-full bg-indigo-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-indigo-600">
                {s.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadPipelineMockup;
